import { StrapiDocument } from '../../General';

interface RFile extends StrapiDocument {
    alternativeText: null | string;
    caption: null | string;
    createdAt: string;
    ext: string;
    formats?: {
        thumbnail: {
            ext: string;
            url: string;
            hash: string;
        };
    };
    hash: string;
    height: number;
    mime: string;
    name: string;
    previewUrl: null;
    provider: string;
    provider_metadata: null;
    size: number;
    updatedAt: string;
    url: string;
    width: number;
}

interface RUploadedLink extends StrapiDocument {
    url: string;
    description: string | null;
    source: string | null;
}

enum RParentFolder {
    INSTITUTIONS = 'institutions',
    PROFILE_PICTURES = 'profilePictures'
}

export type { RFile, RUploadedLink };
export { RParentFolder };
